import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { TodoListItem } from '@unmind/design-system';
import RoutePath from 'App/RoutePath';
import { useTodoListItemTracking } from '../hooks/useTodoListItemTracking';

export const BookPractitionerItem = ({ remaining }: { remaining: number }) => {
  const { t: translate } = useTranslation('homepage', {
    keyPrefix: 'todo_list_section.book_item',
  });
  const { trackClicked } = useTodoListItemTracking('book-practitioner', {
    shown: true,
    completed: false,
  });

  return (
    <TodoListItem
      titleAsChild
      description={translate('description', { remaining })}
      thumbnail={{ icon: 'practitioner', tone: 'tertiary' }}
      cta={translate('cta')}
    >
      <Link to={RoutePath.BookPractitioners} onClick={trackClicked}>
        {translate('title')}
      </Link>
    </TodoListItem>
  );
};
